import { Button } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import { UIModal } from 'features/UI'
import { useTeams } from 'features/Timeline/hooks/useTeams'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { getAddMemberModalTitle } from '../TimelineTeamMemberControlAdd/addMemberModalTitle'
import { TimelineCaregiverTeamMemberFormAdd } from './TimelineCaregiverTeamMemberFormAdd'

interface TimelineCaregiverTeamMemberControlAddProps {
  /** Extra refresh run after a member is added — e.g. invalidating the Family Subscription group. */
  onAfterAdd?: () => void | Promise<void>
}

export function TimelineCaregiverTeamMemberControlAdd({
  onAfterAdd,
}: TimelineCaregiverTeamMemberControlAddProps = {}) {
  const { activeTeamId, activeTeamName, activeTeamType, onRefetchTeamMembers } = useTeams()
  const { user, refreshUser } = useAuthContext()
  const [isOpen, handleOpen, handleClose] = useShowControl()

  if (!activeTeamId) return null

  const handleRefetch = async () => {
    await onRefetchTeamMembers()
    // A Family owner's add took a seat — reload familyContext so the next invite shows the right count.
    if (user?.familyContext) {
      await refreshUser()
    }
    await onAfterAdd?.()
  }

  return (
    <>
      <Button variant="contained" onClick={handleOpen}>
        Add Member
      </Button>

      <UIModal
        title={getAddMemberModalTitle(activeTeamName, activeTeamType)}
        width={800}
        isOpen={isOpen}
        onClose={handleClose}
      >
        <TimelineCaregiverTeamMemberFormAdd
          onClose={handleClose}
          teamId={activeTeamId}
          onRefetchTeamMembers={handleRefetch}
        />
      </UIModal>
    </>
  )
}
